// BTN LOAD MORE
let offsetReleaseNotes;
let containerForBtnNotes = document.querySelector("#more_notes");
let btnLoadMoreNotes = document.querySelector("#btn_more_notes");

if (typeof btnLoadMoreNotes != "undefined" && btnLoadMoreNotes != null) {
  btnLoadMoreNotes.addEventListener("click", function () {
    offsetReleaseNotes = btnLoadMoreNotes.getAttribute("data-offset");
    let dataProduct = btnLoadMoreNotes.getAttribute("data-product");
    let dataUrl = btnLoadMoreNotes.getAttribute("data-url");
    getDataNotes(offsetReleaseNotes, dataProduct, dataUrl);
  });
}
function getDataNotes(offset, product, urlRequest) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params =
    "offset=" + offset + "&product=" + product + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log(request.responseText);
        let response = JSON.parse(request.responseText);
        document.querySelector(".container_all_features").insertAdjacentHTML( 'beforeend', response.html );
        if (
          response.showLoadMore === false ||
          response.showLoadMore === "false"
        ) {
          containerForBtnNotes.classList.add("hide");
        } else {
          console.log("get offset response", response.offset);
          btnLoadMoreNotes.setAttribute("data-offset", response.offset);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

